import { TableCellHeaderProps } from 'components/TableItems/interfaces';

export default (): Array<TableCellHeaderProps & { hidden?: boolean }> => [
  {
    key: 'access',
    i18n: 'ACCESS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'first_name',
    i18n: 'USER_NAME_KEY',
  },
  {
    order: true,
    key: 'email',
    i18n: 'Email',
  },
  {
    order: true,
    key: 'client_name',
    i18n: 'CLIENT_KEY',
  },
  {
    order: true,
    key: 'environment_name',
    i18n: 'ENVIRONMENT_KEY',
  },
  {
    order: true,
    key: 'active',
    i18n: 'STATUS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'mfa_configured',
    i18n: 'SECURITY_KEY',
  },
  {
    order: true,
    key: 'last_access',
    i18n: 'LAST_LOGIN_DATE_KEY',
    centerTitle: true,
  },
  {
    key: 'actions',
    i18n: 'ACTIONS_KEY',
    centerTitle: true,
  },
];
